import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div<{ withBorderBottom?: boolean }>`
    padding: ${rem(25)};
    width: ${rem(320)};
    border-bottom: ${(props) =>
          props.withBorderBottom ? `1px solid ${props.theme.colors.border}` : 'unset'};
    margin: 0 auto ${rem(10)} auto;
    padding: ${rem(25)} ${rem(10)} ${rem(20)} ${rem(10)};

    @media (min-width: ${breakpoints.md}px) {
        width: calc(100% - 60px);
    }
`;

export const Title = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding-bottom: ${rem(25)};
`;

export const Group = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding-top: ${rem(5)};
    padding-bottom: ${rem(10)};
`;

export const Line = styled.div`
    padding: ${rem(2)} 0;
`;

export const InLine = styled.div`
    padding: ${rem(2)} ${rem(30)};
`;

export const Search = styled.div`
    display: flex;
    background: ${({ theme }) => theme.colors.white};
    padding: ${rem(10)};
    position: relative;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(8)};
`;

export const Icon = styled(IconTemplate)`
    svg {
        width: ${rem(24)};
        height: ${rem(24)};
        margin: ${rem(2)} ${rem(5)} 0 0;

        path {
            fill: ${({ theme }) => theme.colors.grey};
            opacity: 0.6;
        }

        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(10)};
        }
    }
`;

export const Input = styled.input`
    width: 100%;
    border: none;
    color: ${({ theme }) => theme.colors.black};

    &::placeholder {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        opacity: 0.6;
    }
`;

export const SearchResults = styled.div`
    position: absolute;
    top: ${rem(51)};
    background: ${({ theme }) => theme.colors.white};
    left: 0;
    padding: ${rem(10)} ${rem(20)};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(8)};
`;

export const SearchResult = styled.span`
    display: block;
    color: ${({ theme }) => theme.colors.dark};
    cursor: pointer;
    padding: ${rem(10)} 0;

    &:hover {
        color: ${({ theme }) => theme.colors.black};
    }
`;

export const SelectedResults = styled.div``;

export const SelectedResult = styled.span`
    display: block;
    background: ${({ theme }) => theme.colors.white};
    padding: ${rem(5)};
    margin: ${rem(10)} 0;
    color: ${({ theme }) => theme.colors.dark};
`;

export const RemoveResult = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: 0 10px;
    cursor: pointer;
`;

export const Item = styled.div``;
